import {api} from '../../api';
import {createMutation} from '../../lib';

const {postCompanies} = api.companies;

export const usePutCompaniesMutation = createMutation((params: Parameters<typeof postCompanies>) =>
  postCompanies(...params),
);
